<template>
    <div>
        <div style="margin-bottom: 20px;margin-top: 30px">
        </div>
        <w-table :columns="columns" :table-data="tableData" ref="wMyTable"
            @getTableSearchSortCon="getTableSearchSortCon" :isPagination="true" :page="page"
            @pageChange="handlePagePagination">
            <template slot="operation" slot-scope="{text,record,index}">
                <el-link type="primary" :underline="false" icon="el-icon-reading" style="margin-right: 10px;"
                    @click="preview(record)">查看邮件内容</el-link>
                <el-link type="primary" :underline="false" icon="el-icon-bottom" style="margin-right: 10px;"
                    v-if="record['hasAttachment']" @click="download(record)">下载附件</el-link>
                <el-dropdown @command="(command) => handleCommand(command, record)">
                    <el-link type="primary" :underline="false" icon="el-icon-d-arrow-right">更多</el-link>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item command="edit">更换邮箱</el-dropdown-item>
                        <el-dropdown-item command="now">立即发送邮件</el-dropdown-item>
                        <el-dropdown-item command="cancel">取消发送邮件</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </template>
            <template slot="toMails" slot-scope="{text,record,index}">
                <ex-fold-table-cell v-if="Array.isArray(text) && text.length > 0"
                    :scope="{ text: text, index }"></ex-fold-table-cell>
            </template>
            <template slot="ccMails" slot-scope="{text,record,index}">
                <ex-fold-table-cell v-if="Array.isArray(text) && text.length > 0"
                    :scope="{ text: text, index }"></ex-fold-table-cell>
            </template>
            <template slot="mailType" slot-scope="{text,record,index}">
                <span v-if="text === 'SAMPLED_NO_INVOICE'">已送样未开票</span>
                <span v-else-if="text === 'CONTRACT_CHANGE_NOTICE'">纯分析合同变更通知</span>
                <span v-else-if="text === 'SINGLE_CELL_DOOR'">单细胞上门</span>
            </template>
            <template slot="mailStatus" slot-scope="{text,record,index}">
                <span v-if="text === 'CREATED'">未发送</span>
                <span v-else-if="text === 'IN_QUEUE'">在队列中</span>
                <span v-else-if="text === 'CANCELED'">已取消发送</span>
                <span v-else>发送成功</span>
            </template>
            <template slot="filterMailType"
                slot-scope="{ setSelectedKeys, selectedKeys, confirm, column,clearFilters  }"
                style="padding: 8px; position: relative; z-index: 9999 !important;width:250px">
                <div style="padding: 10px 15px 0">
                    <el-radio-group v-model="selectedKeys[0]">
                        <el-row :gutter="20">
                            <el-col :span="12">
                                <el-radio label='已送样未开票'>已送样未开票</el-radio>
                            </el-col>
                            <el-col :span="12">
                                <el-radio label='单细胞上门'>单细胞上门</el-radio>
                            </el-col>
                        </el-row>
                        <el-row :gutter="20">
                            <el-col :span="12">
                                <el-radio label='纯分析合同变更通知'>纯分析合同变更通知</el-radio>
                            </el-col>
                        </el-row>
                    </el-radio-group>
                </div>
                <div style="display: flex;padding: 15px">
                    <a-button type="primary" icon="search" size="small" style="width: 90px; margin-right: 8px"
                        @click="() => handleSearch(setSelectedKeys, selectedKeys, confirm, column, clearFilters)">搜索
                    </a-button>
                    <a-button size="small" style="width: 90px" @click="() => handleReset(column, clearFilters)">取消
                    </a-button>
                </div>
            </template>
            <template slot="filterMailStatus"
                slot-scope="{ setSelectedKeys, selectedKeys, confirm, column,clearFilters  }"
                style="padding: 8px; position: relative; z-index: 9999 !important;width:250px">
                <div style="padding: 15px 15px 0">
                    <el-radio-group v-model="selectedKeys[0]">
                        <el-row :gutter="20">
                            <el-col :span="12">
                                <el-radio label='已取消发送'>已取消发送</el-radio>
                            </el-col>
                            <el-col :span="12">
                                <el-radio label='发送成功'>发送成功</el-radio>
                            </el-col>
                        </el-row>
                        <el-row :gutter="20">
                            <el-col :span="12">
                                <el-radio label='未发送'>未发送</el-radio>
                            </el-col>
                            <el-col :span="12">
                                <el-radio label='在队列中'>在队列中</el-radio>
                            </el-col>
                        </el-row>
                    </el-radio-group>
                </div>
                <div style="display: flex;padding: 15px">
                    <a-button type="primary" icon="search" size="small" style="width: 90px; margin-right: 8px"
                        @click="() => handleSearch(setSelectedKeys, selectedKeys, confirm, column, clearFilters)">搜索
                    </a-button>
                    <a-button size="small" style="width: 90px" @click="() => handleReset(column, clearFilters)">取消
                    </a-button>
                </div>
            </template>
        </w-table>
        <picture-loading v-if="loading"></picture-loading>
        <edit-email-address :show-dialog="showEditEmail" v-if="showEditEmail" :select-detail="selectDetail"
            @submit="closeEditEmail"></edit-email-address>
        <preview-email-content :show-dialog="showPreviewContent" v-if="showPreviewContent"
            :select-detail="previewContent" @submit="closePreview"></preview-email-content>
    </div>
</template>

<script>

import TableHeadNote from "@/components/customerTable/TableHeadNote.vue";
import { tableOperationMixin } from "@/mixins/tableOperation";
import PictureLoading from "@/components/customerTable/PictureLoading.vue";
import { cancelSend, downloadEmail, getEmailPage, previewContent, sendNow } from "@/api/dilivery/email";
import { email } from "@/utils/data/tableCol/email/email";
import EditEmailAddress from "@/components/email/EditEmailAddress.vue";
import PreviewEmailContent from "@/components/email/PreviewEmailContent.vue";
import ExFoldTableCell from "@/components/ExFoldTableCell.vue";
import { getDataInLocalStorage } from "@/utils/localStorage";
const baseURL = process.env.VUE_APP_BASE_API

export default {
    name: "Email",
    components: { PreviewEmailContent, EditEmailAddress, PictureLoading, TableHeadNote, ExFoldTableCell },
    mixins: [tableOperationMixin],
    data() {
        return {
            showEditEmail: false,
            previewContent: '',
            showPreviewContent: false,
            searchConditionTag: [],//搜索tag
            sortConditionTag: [],
            tableData: [],
            selectDetail: '',
            page: {
                pageSize: 10,
                currentNum: 1,
                total: null
            },
            loading: true,
        }
    },
    computed: {
        columns() {
            return JSON.parse(JSON.stringify(email(this.searchConditionTag || {})))
        }
    },
    mounted() {
        this.getData()
    },
    methods: {
        async download(row) {
            try {
                let url = `${baseURL}/mail/attachment/${row.id}?Authorization=${getDataInLocalStorage("token")}&Current-Role=${getDataInLocalStorage("role")}`
                const elink = document.createElement('a')
                elink.href = url
                document.body.appendChild(elink)
                elink.click()
                document.body.removeChild(elink);
            } catch (error) {
                console.log(error);
            }
        },
        handleCommand(type, row) {
            switch (type) {
                case 'now':
                    sendNow(row.id).then(res => {
                        if (res.code === 200) {
                            this.$messageUi.success('已添加发送')
                            this.getData()
                        }
                    }).catch(err => { })
                    break;
                case 'edit':
                    this.showEditEmail = true
                    this.selectDetail = row
                    break;
                case 'cancel':
                    cancelSend(row.id).then(res => {
                        if (res.code === 200) {
                            this.$messageUi.error('已取消发送')
                            this.getData()
                        }
                    }).catch(err => { })
                    break;
                default:
                    break;

            }
        },
        preview(row) {
            previewContent(row.id).then(res => {
                if (res.code === 200) {
                    this.showPreviewContent = true
                    this.previewContent = res.data
                }
            }).catch(err => { })
        },
        closePreview(type) {
            this.showPreviewContent = false
            this.previewContent = ''
        },
        closeEditEmail(type) {
            if (type === 'confirm') {
                this.getData()
            }
            this.selectDetail = ''
            this.showEditEmail = false
        },
        getTableSearchSortCon(searchConditionTag, sortConditionTag) {
            this.searchConditionTag = searchConditionTag
            this.sortConditionTag = sortConditionTag
            this.getData('search')
        },
        // 获取数据
        getData(type) {
            this.loading = true
            let params = {
                'page.current': this.page.currentNum,
                'page.size': this.page.pageSize,
            }
            if (type) {
                this.sortConditionTag.forEach(item => {
                    params["order"] = item.colName + "." + item.order
                })
                params['page.current'] = 1
                params['page.size'] = 10
            }
            let sendData = {}
            sendData = this.getSearch(sendData)
            getEmailPage(params, sendData).then(res => {
                this.loading = false
                if (res.code === 200) {
                    this.tableData = res.data.records
                    this.page.currentNum = parseInt(res.data.current)
                    this.page.pageSize = parseInt(res.data.size)
                    this.page.total = parseInt(res.data.total)
                }
            }).catch(() => {
                this.loading = false
            })
        },
        getSearch(sendData) {
            this.searchConditionTag.forEach(item => {
                let value = item.value
                let key = item.key
                if (item.key === 'mailType') {
                    if (item.value === '已送样未开票') {
                        value = 'SAMPLED_NO_INVOICE'
                    } else if (item.value === '单细胞上门') {
                        value = 'SINGLE_CELL_DOOR'
                    } else if (item.value === '纯分析合同变更通知') {
                        value = 'CONTRACT_CHANGE_NOTICE'
                    }
                } else if (item.key === 'mailStatus') {
                    if (item.value === '未发送') {
                        value = 'CREATED'
                    } else if (item.value === '在队列中') {
                        value = 'IN_QUEUE'
                    } else if (item.value === '已取消发送') {
                        value = 'CANCELED'
                    } else {
                        value = 'SENT'
                    }
                } else if (item.key === 'toMails') {
                    key = 'to'
                } else if (item.key === 'ccMails') {
                    key = 'ccs'
                }
                sendData[key] = value
            })
            return sendData
        },
        //页码的变动
        handlePagePagination(page) {
            this.page.currentNum = page.currentNum
            this.page.pageSize = page.pageSize
            this.getData()
        }
    }
}
</script>

<style scoped></style>
